<script>
  import { CalendarDate, DateFormatter, getLocalTimeZone, parseDate, today } from '@internationalized/date'
  import { Calendar } from '$lib/components/ui/calendar/index.js'
  import { Popover, PopoverContent, PopoverTrigger } from '$lib/components/ui/popover/index.js'
  import { Button } from '$lib/components/ui/button/index.js'
  import CalendarIcon from '@lucide/svelte/icons/calendar'

  let { startDate = $bindable(''), endDate = $bindable('') } = $props()

  const formatter = new DateFormatter('en-MY', { dateStyle: 'medium' })

  let startOpen = $state(false)
  let endOpen = $state(false)

  let startValue = $derived(startDate ? parseDate(startDate) : undefined)
  let endValue = $derived(endDate ? parseDate(endDate) : undefined)

  function formatDate(dateStr) {
    if (!dateStr) return ''
    const d = parseDate(dateStr)
    return formatter.format(d.toDate(getLocalTimeZone()))
  }

  function handleStartSelect(value) {
    if (value) {
      startDate = value.toString()
      startOpen = false
      // If end date is before new start date, clear it
      if (endDate && parseDate(endDate).compare(value) < 0) {
        endDate = ''
      }
    }
  }

  function handleEndSelect(value) {
    if (value) {
      endDate = value.toString()
      endOpen = false
    }
  }
</script>

<div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
  <div class="flex flex-col gap-1.5">
    <!-- svelte-ignore a11y_label_has_associated_control -->
    <label class="text-sm font-medium text-foreground">Start Date</label>
    <Popover bind:open={startOpen}>
      <PopoverTrigger>
        {#snippet child({ props })}
          <Button variant="outline" {...props} class="h-9 w-full justify-start text-left font-normal {!startDate ? 'text-muted-foreground' : ''}">
            <CalendarIcon class="mr-2 h-4 w-4" />
            {startDate ? formatDate(startDate) : 'Pick a date'}
          </Button>
        {/snippet}
      </PopoverTrigger>
      <PopoverContent class="w-auto p-0" align="start">
        <Calendar
          type="single"
          value={startValue}
          onValueChange={handleStartSelect}
          captionLayout="dropdown"
        />
      </PopoverContent>
    </Popover>
  </div>

  <div class="flex flex-col gap-1.5">
    <!-- svelte-ignore a11y_label_has_associated_control -->
    <label class="text-sm font-medium text-foreground">End Date</label>
    <Popover bind:open={endOpen}>
      <PopoverTrigger>
        {#snippet child({ props })}
          <Button variant="outline" {...props} class="h-9 w-full justify-start text-left font-normal {!endDate ? 'text-muted-foreground' : ''}">
            <CalendarIcon class="mr-2 h-4 w-4" />
            {endDate ? formatDate(endDate) : 'Pick a date'}
          </Button>
        {/snippet}
      </PopoverTrigger>
      <PopoverContent class="w-auto p-0" align="start">
        <Calendar
          type="single"
          value={endValue}
          onValueChange={handleEndSelect}
          minValue={startValue}
          captionLayout="dropdown"
        />
      </PopoverContent>
    </Popover>
  </div>
</div>
